import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'common/components/Intl';
import { configureLocales } from 'common/locales';

import store from '../store';

global.translations && configureLocales(global.translations.locale);

export default class WrappedBase extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <IntlProvider>{this.props.children}</IntlProvider>
      </Provider>
    );
  }
}
